var newValidateRegExpCore = require('./newValidateRegExpCore');
var and = require('shared').booleanValidate.and;

function newValidateRegExp(pattern, flag) {
	var validateCore = newValidateRegExpCore(pattern, flag);
	return and(validateCore);
}

module.exports = newValidateRegExp;